/**
 * Workplace Injury Guard
 *
 * Guards that check if the visit is related to a workplace injury.
 */

import type { GuardWithMetadata } from "./sms.guard";

/**
 * Is Workplace Injury Guard
 *
 * Checks if the patient answered "Yes" to the workplace injury question.
 * This determines the workers' comp pricing path (full WC vs EPS).
 *
 * NOTE: Guards run BEFORE actions, so we check event.data (not context)
 */
export const isWorkplaceInjury: GuardWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState guard params are complex
  impl: ({ context, event }: { context: any; event: any }) => {
    if (event.data && typeof event.data.isWorkplaceInjury === "boolean") {
      return event.data.isWorkplaceInjury === true;
    }

    // Fallback to context (for state restoration)
    return context.isWorkplaceInjury === true;
  },
  metadata: {
    displayName: "isWorkplaceInjury",
    description: "Patient answered YES to workplace injury question",
    requiresContext: ["isWorkplaceInjury"],
    category: "context",
  },
};
